export default __webpack_public_path__ + "static/media/green_down_arrow.d894ef12.svg";